export const SidebarIdOperationsGeneralConfiguration = 'OPERATIONS_GENERAL_CONFIGURATION' as const;
